/* tslint:disable */
/* eslint-disable */
export enum AuctionControlType {
  Auctioneer = 'auctioneer',
  Automatic = 'automatic'
}
